import { render, staticRenderFns } from "./KeywordTags.vue?vue&type=template&id=35a8d17a&"
import script from "./KeywordTags.vue?vue&type=script&lang=js&"
export * from "./KeywordTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports